import { GenericErrorMessage } from "./GenericErrorMessage";
import PageWrapper from "./PageWrapper";

export const GenericErrorPage = (props: { alternateInstruction?: string }) => (
    <PageWrapper>
        <GenericErrorMessage alternateInstruction={props.alternateInstruction} />
    </PageWrapper>
);
